/* eslint-disable no-param-reassign */
import moment from 'moment';
import { toast } from 'react-toastify';
import { API } from '../config';
import { raiseErrorException } from '../../utils/raiseErrorException';
import {
  start,
  setAllChangeLogFromID,
  setAllNotifications,
  setAllScheduledUpdates,
  setChangeLog,
  setChangeLogNotification,
  setCloseNotification,
  setCloseNotificationBanner,
  setCreateChangeLog,
  setCreateNotification,
  setCreateScheduledUpdate,
  setDeleteChangeLog,
  setDeleteNotification,
  setDeleteScheduledUpdate,
  setNotification,
  setScheduledUpdate,
  setUpdateNotification,
  setUpdateScheduledUpdate,
  setReducerError,
  setSSENotifications,
} from '../reducers/notificationReducer';
import { getLocalStorageData } from '../../utils/LocalStorage';

// get all notification banners
export const getAllNotifications = () => async (dispatch) => {
  const userID = getLocalStorageData('loggedInUserID');
  try {
    dispatch(start());
    const response = await API.get(`/notifications/banner?userID=${userID}`);

    dispatch(setAllNotifications(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'get');
  }
};

// create Notification Banners
export const createNotification = (data, toggle) => async (dispatch) => {
  data.displayTime = moment(data.displayTime).utc().format('YYYY-MM-DD HH:mm');
  data.warningTime = moment(data.warningTime).utc().format('YYYY-MM-DD HH:mm');
  data.bannerHideTime = moment(data.bannerHideTime).utc().format('YYYY-MM-DD HH:mm');
  try {
    dispatch(start());
    const response = await API.post('/notifications/banner', data);

    dispatch(setCreateNotification(response.data));
    toggle();
    toast.success('Notification created successfully');
    dispatch(getAllNotifications());
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'post');
  }
};

// get notification by id
export const getNotificationById = (id) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/notifications/banner/${id}`);
    return dispatch(setNotification(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'get');
  }
};

// update notification by id
export const updateNotificationById =
  (id, name, message, isActive, isWarningActive, warningMessage, displayTime, warningTime, bannerHideTime) =>
  async (dispatch) => {
    try {
      displayTime = moment(displayTime).utc().format('YYYY-MM-DD HH:mm');
      warningTime = moment(warningTime).utc().format('YYYY-MM-DD HH:mm');
      bannerHideTime = moment(bannerHideTime).utc().format('YYYY-MM-DD HH:mm');

      dispatch(start());
      const response = await API.put(`/notifications/banner/${id}`, {
        name,
        message,
        isActive,
        isWarningActive,
        warningMessage,
        displayTime,
        warningTime,
        bannerHideTime,
      });
      dispatch(getAllNotifications());
      toast.success('Banner Notification Updated Successfully');

      dispatch(setUpdateNotification(response.data));
    } catch (error) {
      raiseErrorException(error, dispatch, setReducerError, 'put');
    }
  };

// delete notification by id
export const deleteNotificationById = (id) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.delete(`/notifications/banner/${id}`);
    dispatch(getAllNotifications());
    toast.success('Banner Notification Deleted Succuessfully');

    return dispatch(setDeleteNotification(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'delete');
  }
};

// get notification banner by name
export const getNotificationByName = (name) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/notifications/banner/${name}`);

    return dispatch(setNotification(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'get');
  }
};

// close notification banner by id
export const closeNotificationById = (bannerID, userID, setVisible) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post(`/notifications/banner/${bannerID}/close/?userID=${userID}`);

    dispatch(setCloseNotification(response.data));
    toast.success('Notification closed successfully');
    setVisible(false);
    dispatch(getAllNotifications());
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'post');
  }
};
// close notification banner
export const closeNotificationBanner = (bannerIDS, setModal) => async (dispatch) => {
  const userID = getLocalStorageData('loggedInUserID');
  try {
    dispatch(start());
    const response = await API.post(`/notifications/banner/close?userID=${userID}`, bannerIDS);

    dispatch(setCloseNotificationBanner(response.data));
    toast.success('Notification closed successfully');
    setModal(false);
    dispatch(getAllNotifications());
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'post');
  }
};
// close notification banner
export const changeLogNotification = () => async (dispatch) => {
  const userID = getLocalStorageData('loggedInUserID');
  try {
    dispatch(start());
    const response = await API.get(`/notifications/update/latest/changelog?userID=${userID}`);

    dispatch(setChangeLogNotification(response.data));
    // setModal(false);
    // dispatch(getAllNotifications());
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'get');
  }
};
// close change log notification
export const closeChangeLogNotification = (updateID) => async (dispatch) => {
  const userID = getLocalStorageData('loggedInUserID');
  try {
    dispatch(start());
    const response = await API.post(`notifications/update/${updateID}/close?userID=${userID}`);

    dispatch(setCloseNotification(response.data));
    toast.success('Notification closed successfully');
    // setModal(false);
    // dispatch(getAllNotifications());
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'post');
  }
};

// get all scheduled updates
export const getAllScheduledUpdates = () => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get('/notifications/update');

    return dispatch(setAllScheduledUpdates(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'get');
  }
};
// get all changelog on basis of id
export const getAllChangeLogFromID = (id) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/notifications/update/${id}/changelog`);

    return dispatch(setAllChangeLogFromID(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'get');
  }
};
// create changelog on basis of id
export const createChangeLogNotificaton = (id, description, type, note) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post(`/notifications/update/${id}/changelog`, {
      description,
      type,
      note,
    });
    dispatch(getAllChangeLogFromID(id));

    return dispatch(setCreateChangeLog(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'post');
  }
};

// create update update
export const createScheduledUpdate = (version, title, summary, date) => async (dispatch) => {
  date = moment(date).utc().format('YYYY-MM-DD HH:mm');
  try {
    dispatch(start());
    const response = await API.post('/notifications/update', {
      version,
      title,
      summary,
      date,
    });
    toast.success('Notification created successfully');
    dispatch(getAllScheduledUpdates());

    return dispatch(setCreateScheduledUpdate(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'post');
  }
};

// create update with updateID
export const updateScheduledUpdatewithUpdateID = (id, version, title, summary, date) => async (dispatch) => {
  date = moment(date).utc().format('YYYY-MM-DD HH:mm');
  try {
    dispatch(start());
    const response = await API.put(`/notifications/update/${id}`, {
      version,
      title,
      summary,
      date,
    });
    toast.success('Notification created successfully');
    dispatch(getAllScheduledUpdates());

    return dispatch(setUpdateScheduledUpdate(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'put');
  }
};
// create update with updateID
export const deleteScheduledUpdatewithUpdateID = (id) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.delete(`/notifications/update/${id}`);
    toast.success('Notification deleted successfully');
    dispatch(getAllScheduledUpdates());
    return dispatch(setDeleteScheduledUpdate(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'delete');
  }
};

// get scheduled update by id
export const getScheduledUpdateById = (id) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/notifications/scheduled/${id}`);

    return dispatch(setScheduledUpdate(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'get');
  }
};

// update scheduled update by id
export const updateScheduledUpdateById = (id, formData) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.patch(`/notifications/scheduled/${id}`, formData);

    return dispatch(setUpdateScheduledUpdate(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'patch');
  }
};

// delete scheduled update by id
export const deleteScheduledUpdateById = (id) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.delete(`/notifications/scheduled/${id}`);

    return dispatch(setDeleteScheduledUpdate(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'delete');
  }
};

// get changelog by update id
export const getChangelogByUpdateId = (id) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/notifications/changelog/${id}`);
    return dispatch(setChangeLog(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'get');
  }
};

// create changelog
export const createChangelog = (formData) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post('/notifications/changelog', formData);
    return dispatch(setCreateChangeLog(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'post');
  }
};
// delete changelog by changelog ID
export const deleteChangelogfromID = (id) => async (dispatch) => {
  const updateID = getLocalStorageData('updateID');
  try {
    dispatch(start());
    const response = await API.delete(`/notifications/changelog/${id}`);
    dispatch(getAllChangeLogFromID(updateID));
    toast.success('Changelog Deleted Successfully');
    return dispatch(setDeleteChangeLog(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'delete');
  }
};

// get changelog by id
export const getChangelogById = (id) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/notifications/changelog/${id}`);
    return dispatch(setChangeLog(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'get');
  }
};

// delete changelog by id
export const deleteChangelogById = (id) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.delete(`/notifications/changelog/${id}`);
    return dispatch(setDeleteChangeLog(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'delete');
  }
};

// Subscribe SSE
export const getSSENotifications = () => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get('/notifications/subscribeSSE');
    return dispatch(setSSENotifications(response?.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'get');
  }
};
